module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.findindex/~/es-abstract/helpers/mod.js
// module id = 209
// module chunks = 2